import { Button, styled } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import StyledLoadingButton from '../Common/LoadingButton';

type ButtonProps = {
  onClick?: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  fullWidth?: boolean;
  startIcon?: string;
  endIcon?: boolean;
  paddingX?: number;
  paddingY?: number;
  children: string;
  loading?: boolean;
  loadingText?: string;
  isSelected: boolean | null;
};

type ICommonButtonProps = {
  isSelected: boolean | null;
};

const CommonButton = styled(Button)<ICommonButtonProps>(({ theme, isSelected }) => ({
  borderRadius: 5,
  background: isSelected ? 'var(--Accent-Moonstone-Blue, #7CAEBE)' : 'transparent',
  color: isSelected ? '#fff' : theme.palette.primary.main,
  border: '1px solid rgba(124, 174, 190, 0.50)',
  '&:hover': {
    border: '1px solid rgba(124, 174, 190, 0.50)',
    background: isSelected ? 'var(--Accent-Moonstone-Blue, #7CAEBE)' : '',
  },
}));

function BookingsButton({
  onClick,
  disabled,
  fullWidth,
  startIcon,
  endIcon,
  children,
  paddingX,
  paddingY,
  loading,
  loadingText,
  isSelected,
}: ButtonProps) {
  if (!loading) {
    return (
      <CommonButton
        type="submit"
        color="primary"
        disabled={disabled}
        fullWidth={fullWidth}
        variant="outlined"
        onClick={onClick}
        startIcon={startIcon ? <img src={startIcon} alt={startIcon} /> : null}
        endIcon={endIcon ? <ArrowForwardRoundedIcon /> : null}
        sx={{
          textTransform: 'none !important',
          padding: `${paddingY}px ${paddingX}px !important`,
        }}
        isSelected={isSelected}
      >
        {children}
      </CommonButton>
    );
  }
  return <StyledLoadingButton fullWidth={fullWidth}>{loadingText || children}</StyledLoadingButton>;
}

BookingsButton.defaultProps = {
  paddingX: 100,
  paddingY: 16,
};

export default BookingsButton;
